export default __webpack_public_path__ + "3eb978489377587da7aa1a77331d0cec.svg";